import React from "react";

import { logger } from "@synthesis/shared-utils";

import { getVersions, updateFile, type DocumentListResponse } from "../../../api";
import { useStores } from "../../../store";

export const useVersions = (id?: string) => {
  const { generalStore, directoryStore } = useStores();
  const [versions, setVersions] = React.useState<DocumentListResponse[] | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const getVersionsList = React.useCallback(async (fileId: string) => {
    if (fileId) {
      setIsLoading(true);
      try {
        const responseData = (await getVersions({ path: { id: fileId } })).data;

        setVersions(responseData);

        setIsLoading(false);
      } catch (err) {
        logger.error("useVersions", err);
      }
    }
  }, []);

  const postVersion = React.useCallback(
    async (fileId: string, data: File) => {
      setIsLoading(true);
      const body = {
        id: fileId,
        document: data,
      };

      try {
        const updatedFile = (await updateFile({ body })).data;
        getVersionsList(fileId);
        setIsLoading(false);
        generalStore.getContents(directoryStore.rootFolderId);

        return updatedFile;
      } catch (err) {
        logger.error("updateFile", err);
      }
    },
    [getVersionsList, generalStore, directoryStore],
  );

  React.useEffect(() => {
    if (id) getVersionsList(id);
  }, [getVersionsList, id]);

  return { isLoading, versions, getVersions: getVersionsList, postVersion };
};
